import React from 'react';

export function BannerSection() {
  return (
    <>
      {/* Banner Image */}
      <div className="bg-white py-2 md:py-8 flex justify-center">
        <img
          src="https://restaff.b-cdn.net/Screenshots/Banner%20Before%20Restaff.png"
          alt="Before ReStaff — workforce management challenges"
          loading="lazy"
          className="w-full md:w-[47%] h-auto md:rounded-xl"
        />
      </div>

      {/* Demo Video */}
      <div className="bg-white py-4 md:py-10 px-4">
        <div
          className="max-w-4xl mx-auto w-full"
          style={{ position: 'relative', aspectRatio: '1.90', boxSizing: 'content-box' }}
        >
          <iframe
            src="https://app.supademo.com/embed/cmm1b10a40m4pvkq1l9eor1vu?embed_v=2&utm_source=embed"
            loading="lazy"
            title="Manage Staff, Schedules, and Tasks in Restaff"
            allow="clipboard-write"
            frameBorder="0"
            allowFullScreen
            style={{
              position: 'absolute', top: 0, left: 0,
              width: '100%', height: '100%', borderRadius: '12px',
            }}
          />
        </div>
      </div>
    </>
  );
}
